export default {
  id: 141,
  title: 'Target #141 - Third Eye',
  url: 'https://cssbattle.dev/play/141',
  colors: ['#E3516E', '#D9D9D9'],
  solution:
    '<a a><a b><style>body{background:#e3516e}a{position:fixed;background:#d9d9d9}[a]{top:-75;left:-75;width:150;height:150;border-radius:9in;box-shadow:400px 300px #d9d9d9}[b]{top:100;left:150;width:100;height:100;border-radius:9in 0;transform:rotate(45deg)}</style>',
}
